import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Header from './Header';
import Footer from './Footer';

const LOCAL_BUSINESS_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': ['LocalBusiness', 'HomeAndConstructionBusiness'],
  name: 'Apex Rénovation',
  description: 'Artisans rénovation maison et commerce à Châteauroux. Rénovation intérieure, cuisine, salle de bain, isolation, toiture, façade dans le Berry. Garantie décennale.',
  url: 'https://apexrenovation.fr',
  telephone: '+33254012345',
  email: 'contact@apexrenovation.fr',
  priceRange: '€€',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '2 rue du Gué de la Chapelle',
    addressLocality: 'Saint-Maur',
    postalCode: '36250',
    addressRegion: 'Indre',
    addressCountry: 'FR',
  },
  areaServed: [
    { '@type': 'AdministrativeArea', name: 'Indre' },
    { '@type': 'AdministrativeArea', name: 'Cher' },
    { '@type': 'City', name: 'Châteauroux' },
    { '@type': 'City', name: 'Bourges' },
    { '@type': 'City', name: 'Issoudun' },
  ],
  openingHoursSpecification: [
    { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Monday','Tuesday','Wednesday','Thursday','Friday'], opens: '08:00', closes: '18:00' },
  ],
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Prestations de rénovation',
    itemListElement: [
      'Rénovation intérieure complète',
      'Rénovation de cuisine',
      'Rénovation de salle de bain',
      'Isolation thermique et phonique',
      'Réfection de toiture',
      'Ravalement de façade',
      'Petits travaux',
      'Aménagement de bureau',
      'Rénovation commerciale',
    ].map((name) => ({ '@type': 'Offer', itemOffered: { '@type': 'Service', name } })),
  },
};

export default function Layout({ children }) {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="flex flex-col min-h-screen">
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(LOCAL_BUSINESS_SCHEMA)}
        </script>
      </Helmet>
      <Header />
      {/* pt-[104px] = top bar 40px + main nav 64px */}
      <main className="flex-1 pt-16 md:pt-[104px]">{children}</main>
      <Footer />
    </div>
  );
}
